export default __webpack_public_path__ + "static/media/armageddonfalls.b9451f12.png";